export default __webpack_public_path__ + "static/media/myDNA-logo.45317ed1.png";